import './index.scss';

function HeaderLinkDivider() {
    return <span className="header-link-divider border-start border-primary my-auto" />
}

export default HeaderLinkDivider;